import { render, staticRenderFns } from "./health-hea2.vue?vue&type=template&id=2b7d1774&scoped=true"
import script from "./health-hea2.vue?vue&type=script&lang=js"
export * from "./health-hea2.vue?vue&type=script&lang=js"
import style0 from "./health-hea2.vue?vue&type=style&index=0&id=2b7d1774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d1774",
  null
  
)

export default component.exports